import { HTML_LINK_TARGET } from '../../../../constants/html'
import { EPOST_POST_SERVICE_TRACKING_URL } from '../../Epost.constants'

export const EPOST_TIMELINE_TRACKING_ID_POST_SERVICE_CLICK_EVENT_ARGS = {
  link: EPOST_POST_SERVICE_TRACKING_URL,
  outsideLink: true,
  target: HTML_LINK_TARGET.blank,
}

export const EPOST_TIMELINE_TRACKING_ID_COPY_BUTTON_DISABLED_TIMEOUT = 5000
